import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Helmet } from 'react-helmet';
import { Grid, Typography } from '@mui/material';
import ProfileForm from './ProfileForm';
import ProfileCompany from './ProfileCompany';

import { getCurrentCompany, getCurrentCompanyStatistics } from '../../../actions/companiesActions';
import { resetCompaniesState } from '../../../slices/companiesSlice';

const styles = {
  title: {
    marginBottom: '1rem'
  },
  column: {
    paddingX: '1rem'
  }
}

const Profile = () => {
  const dispatch = useDispatch();
  const profile = useSelector(state => state.auth.profile);

  useEffect(() => {
    if(profile.companyRef?._id) {
      dispatch(getCurrentCompany({ id: profile.companyRef?._id }));
      dispatch(getCurrentCompanyStatistics({ id: profile.companyRef?._id }));
    }
    
    return () => dispatch(resetCompaniesState())
  }, [profile.companyRef]);
  
  return (
    <>
      <Helmet>
        <title>Cristopher | Mi perfil</title>
      </Helmet>
      <Typography variant="h5" sx={styles.title} fontWeight="bold">Perfil</Typography>
      <Grid container>
        <Grid item xs={12} md={6} sx={styles.column}>
          <ProfileForm />
        </Grid>
        <Grid item xs={12} md={6} sx={styles.column}>
          <ProfileCompany />
        </Grid>
      </Grid>
    </>
  );
}

export default Profile;
